import {
    Box,
} from "@mui/material"
import React from "react"
import schadenshistorieUi from "./schadenshistorie.json"
import Widget from "../../../Widget"
import SchadenshistorieTableRow from "./SchadenshistorieTableRow"
const SchadenhistorieTable = ({
    rows,
}) => {
    const container = schadenshistorieUi
    const {children} = container
    const headerWidgets = container.children?.filter(entry => entry.y === 0)
    const contentWidgets = container.children?.filter(entry => entry.y === 1)
    
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: `repeat(${children?.columncount}, 1fr)`,
            }}
        >
            {headerWidgets?.map(widget => (
                <Box
                    key={widget.id}
                    bgcolor={"#f8f9fa"}
                    padding={2}
                    sx={{
                        gridColumn: widget.x + 1 + " /span " + widget.w,
                        gridRow: widget.y + 1 + " /span " + widget.h,
                    }}
                >
                    <Widget widget={widget} />
                </Box>
            ))}
            {rows?.length ? (
                rows.map((row, key) =>
                    contentWidgets?.map(widget => (
                        <SchadenshistorieTableRow
                            key={widget.id + key}
                            row={row}
                            widget={widget}
                            rowCount={key}
                        />
                    )),
                )
            ) : (
                <Box
                    padding={2}
                    sx={{
                        gridColumn: 1 + " /span " + children?.columncount,
                    }}
                >
                    Keine Einträge
                </Box>
            )}
        </Box>
    )
}

export default SchadenhistorieTable
